import Image from "@/components/image";
import Text from "@/components/text/text";

interface DialogProps {
  image?: string;
  title?: string;
  desc?: string;
  buttonText?: string;
  spacing?: number; // spacing between image and text
  onClick: () => void;
}

export default function Dialog({
  image = "/assets/icon_lightbulb.png",
  title,
  desc,
  buttonText = "btn_next",
  spacing = 16,
  onClick,
}: DialogProps) {
  return (
    <div className="fixed inset-0 z-[53] flex items-center justify-center">
      <div className="fixed w-full h-full bg-overlay"></div>
      <div className="fixed w-[329px]">
        <div className="relative">
          <div className="gradient-border-outer">
            <div
              className={`gradient-border rounded-lg bg-chatpanel grid text-center max-w-[329px]`}
            >
              <div className="mb-[20px]">
                <div className={`flex justify-center mb-[${spacing}px]`}>
                  <Image src={image} width={60} height={60} />
                </div>
                {title && (
                  <Text
                    text={title}
                    size={15}
                    className={`font-bold uppercase mb-[${spacing}px]`}
                  />
                )}
                {desc && <Text text={desc} size={15} />}
              </div>
              <button
                className="btn-style primary-btn"
                onClick={() => onClick()}
              >
                <Text text={buttonText} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
